import store from '@/store/store'

 
export default {
    user () {
        return store.state.auth.userInfo
    },
 
    check () {
       
        console.log('check');
        return localStorage.getItem('access_token') //get token from localStorage 
    },

    isAuthenicated() {

        if(localStorage.getItem('access_token') !== null) {

            if(store.state.auth.userInfo == null) {

                store.dispatch('getUserInfo').then((response) => {

                    console.log(response);
                    // return true;
        
                }).catch((error) => {
                    console.log(error);
                });
                
            } 
            
        }

        // return true;
        
    }
}